import { render, staticRenderFns } from "./CompleteInvitation.vue?vue&type=template&id=4ad67a5c&"
import script from "./CompleteInvitation.vue?vue&type=script&lang=js&"
export * from "./CompleteInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports